import script from "./exchangeCouponRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./exchangeCouponRecord.vue?vue&type=script&setup=true&lang=js"

import "./exchangeCouponRecord.vue?vue&type=style&index=0&id=e83b48fa&scoped=true&lang=less"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e83b48fa"]])

export default __exports__